<template>
  <div>
    <div class="ccui-navigation" ref="noPrintTop">
      <el-button
        size="mini"
        type="primary-icon-medium"
        icon="icon-ccui-return"
        @click="handleBack"
      >
        返回
      </el-button>
      <div class="ccui-navigation-divider" />
      <!-- 面包屑 -->
      <el-breadcrumb
        class="ccui-navigation-crumbs-container"
        separator-class="el-icon-arrow-right"
      >
        <el-breadcrumb-item
          :to="{ path: $store.getters.getBreadcrumb('level1').path }"
          >{{ $store.getters.getBreadcrumb("level1").name }}</el-breadcrumb-item
        >
        <el-breadcrumb-item
          :to="{ path: '/applicationSettings/userManagement' }"
          >应用设置</el-breadcrumb-item
        >
        <el-breadcrumb-item
          :to="{ path: '/applicationSettings/userManagement' }"
          >权限管理</el-breadcrumb-item
        >
        <el-breadcrumb-item
          :to="{ path: '/applicationSettings/userManagement' }"
          >用户管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>
          设置
          <span class="ccui-curr-crumb ccui-ml-10">
            {{ userName }}
          </span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="ccui-app-container-detail2" style="padding-bottom: 20px">
      <div class="ccui-app-container-detail-body">
        <el-tabs v-model="activeNameTab" class="el-tabs__customize">
          <el-tab-pane label="用户信息" name="basicInfor">
            <template>
              <basic-infor
                ref="basicInfor"
                @getSubmit="getSubmit"
              ></basic-infor>
            </template>
          </el-tab-pane>
          <el-tab-pane label="角色设置" name="roleSetting">
            <template>
              <role-setting
                ref="roleSetting"
                @getSubmit="getSubmit"
              ></role-setting>
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import BasicInfor from "../components/basicInfor";
import RoleSetting from "../components/roleSetting";
import { getAppUser } from "../api/item-list";
import { ishasAgentId } from "@/basa/utils";
export default {
  name: "userManage-setting",
  components: {
    BasicInfor,
    RoleSetting
  },
  data() {
    return {
      activeNameTab: "basicInfor",
      roleId: "basicInfor",
      userName: "",
      formData: {},
      infoTitle: [],
      submitFlag: false
    };
  },
  created() {
    this.roleId = this.$route.params.roleId;
    this.getListDetail();
  },
  methods: {
    getSubmit() {
      debugger;
      this.submitFlag = true;
    },
    // 详情请求
    getListDetail() {
      getAppUser({ id: this.roleId }).then(res => {
        this.userName = res.data.data.name;
      });
    },
    // 返回
    handleBack() {
      this.$router.push("/applicationSettings/userManagement");
    }
  },
  // 更改列表缓存状态
  beforeRouteLeave(to, from, next) {
    if (this.submitFlag === true) {
      for (var key in this.$vnode.parent.componentInstance.cache) {
        delete this.$vnode.parent.componentInstance.cache[
          ishasAgentId(to.path, key)
        ];
      }
    }
    next();
  }
};
</script>
